module.exports = __webpack_public_path__ + "about-header.jpg?26408ccfca9e012ca387f18b310ada0a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about-header.jpg
// module id = 245
// module chunks = 0